import { CommonEnums } from '../../common.enums'

export class Gps_Inst {
    gps_Inst_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Id: string;
    dxFlow_Id: number;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    disableFlg: string;
    src_ConnNm: string;
    tgt_ConnNm: string;
    retryEnabled: string;
    numOfRetryAttempts: number;
    retryWaitTime: number;
    valid_Cd: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.gps_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Id = CommonEnums.defaults.STRING_EMPTY;
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.disableFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.updateDt = new Date();
        this.src_ConnNm = CommonEnums.defaults.STRING_EMPTY;
        this.tgt_ConnNm = CommonEnums.defaults.STRING_EMPTY;
        this.retryEnabled = CommonEnums.defaults.STRING_VAL_NO;
        this.numOfRetryAttempts = 2;
        this.retryWaitTime = 60;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(gps_InstTmp: Gps_Inst): Gps_Inst {
        let gps_Inst: Gps_Inst = new Gps_Inst();
        gps_Inst.copyFrom(gps_InstTmp);
        return gps_Inst;
    }

    copy(): Gps_Inst {
        let gps_InstTmp: Gps_Inst = new Gps_Inst();

        gps_InstTmp.gps_Inst_Id = this.gps_Inst_Id;
        gps_InstTmp.nm = this.nm;
        gps_InstTmp.description = this.description;
        gps_InstTmp.ver = this.ver;
        gps_InstTmp.valid_Id = this.valid_Id;
        gps_InstTmp.dxFlow_Id = this.dxFlow_Id;
        gps_InstTmp.updateBy = this.updateBy;
        gps_InstTmp.lastUpdateBy = this.lastUpdateBy;
        gps_InstTmp.disableFlg = this.disableFlg;
        gps_InstTmp.updateDt = this.updateDt;
        gps_InstTmp.src_ConnNm = this.src_ConnNm;
        gps_InstTmp.tgt_ConnNm = this.tgt_ConnNm;
        gps_InstTmp.retryEnabled = this.retryEnabled;
        gps_InstTmp.numOfRetryAttempts = this.numOfRetryAttempts;
        gps_InstTmp.retryWaitTime = this.retryWaitTime;
        gps_InstTmp.valid_Cd = this.valid_Cd;

        return gps_InstTmp
    }

    copyFrom(gps_InstTmp: Gps_Inst): void {
        this.gps_Inst_Id = gps_InstTmp.gps_Inst_Id;
        this.nm = gps_InstTmp.nm;
        this.description = gps_InstTmp.description;
        this.ver = gps_InstTmp.ver;
        this.valid_Id = gps_InstTmp.valid_Id;
        this.dxFlow_Id = gps_InstTmp.dxFlow_Id;
        this.updateBy = gps_InstTmp.updateBy;
        this.lastUpdateBy = gps_InstTmp.lastUpdateBy;
        this.disableFlg = gps_InstTmp.disableFlg;
        this.updateDt = gps_InstTmp.updateDt;
        this.src_ConnNm = gps_InstTmp.src_ConnNm;
        this.tgt_ConnNm = gps_InstTmp.tgt_ConnNm;
        this.retryEnabled = gps_InstTmp.retryEnabled;
        this.numOfRetryAttempts = gps_InstTmp.numOfRetryAttempts;
        this.retryWaitTime = gps_InstTmp.retryWaitTime;
        this.valid_Cd = gps_InstTmp.valid_Cd;
    }

    compare(gps_InstTmp: Gps_Inst): string {
        let gps_InstString: string = this.toString(false);
        let gps_InstTmpString: string = gps_InstTmp.toString(false);

        if (gps_InstString != gps_InstTmpString) {
            return gps_InstString + ', ' + gps_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Gps_Inst [gps_Inst_Id=" + this.gps_Inst_Id + ", nm=" + this.nm +
            ", description=" + this.description + ", valid_Id=" + this.valid_Id +
            ", dxFlow_Id=" + this.dxFlow_Id + ", disableFlg=" + this.disableFlg +
            ",retryEnabled=" + this.retryEnabled +
            ",numOfRetryAttempts=" + this.numOfRetryAttempts +
            ",retryWaitTime=" + this.retryWaitTime +
            ",valid_Cd= "+ this.valid_Cd +
            ", src_ConnNm=" + this.src_ConnNm + ", tgt_ConnNm=" + this.tgt_ConnNm;

        if (isNotCompare) {
            str += ", ver =" + this.ver + ", updateBy=" + this.updateBy +
                ", lastUpdateBy=" + this.lastUpdateBy + ", updateDt=" + this.updateDt;
        }

        str += "]";
        return str;
    }
}